import image from '../../assets/logotype.png';
import styled from './Logotype.module.css';


const Logotype = () => {


    return (

        <div>
        <img className={styled.image} src={image} alt='Logo-automotriz'/>
        </div>

    )

}


export default Logotype;